const iApi = {
    methods: {
        callApi: function (verb, endpoint, data, success_fn, error_fn) {
            return jQuery.ajax({
                type: verb,
                dataType: "json",
                url: home_url + '/wp-json/dash_public/v1' + endpoint,
                data: data,
                success: success_fn,
                error: error_fn
            });
        },
    }
};

export default iApi;
